import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';

import { addLocaleToPathIfNeeded } from '../../utils';

export class LocalizedBreadcrumbsItem extends React.Component {
    render() {
        const { disabled, showBrandName, BRAND_NAME } = this.props;

        if (showBrandName) {
            return (
                <BreadcrumbsItem to={addLocaleToPathIfNeeded(this.props)} disabled={disabled}>
                    {BRAND_NAME}
                </BreadcrumbsItem>
            );
        } else {
            return (
                <BreadcrumbsItem to={addLocaleToPathIfNeeded(this.props)} disabled={disabled}>
                    {this.props.children}
                </BreadcrumbsItem>
            );
        }
    }
}
const mapStateToProps = state => {
    return {
        locale: state.i18n.locale,
        BRAND_NAME: state.i18n.common.BRAND_NAME
    };
};

LocalizedBreadcrumbsItem.propTypes = {
    disabled: PropTypes.bool,
    brandName: PropTypes.bool
};

export default connect(mapStateToProps)(LocalizedBreadcrumbsItem);



// WEBPACK FOOTER //
// ./src/components/breadcrumb/LocalizedBreadcrumbsItem.js